module.exports = __webpack_public_path__ + "static/media/sidebar-2.a66ca4a2.jpg";